import { VueModule } from '@Foundation/utilities';
import VueScrollSnap from './code/Scripts/components/vue-scroll-snap.vue';

export default VueModule({
    components: {
        VueScrollSnap
    }
});